import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import { Tabs, Tab, TabList } from 'aquilla/core/molecules/Tabs';
import useScrollInfo from './useScrollInfo';

const NavContainer = styled.div`
  background: var(--color-i-white);
  position: sticky;
  top: 72px;
  z-index: 2;
  border: ${Spacings.SPACING_1} solid var(--color-divider);
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B};
    overflow-x: auto;
    white-space: nowrap;
    top: 48px;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;
const TabContainer = styled.div`
  width: 1136px;
  margin: auto;
`;

const StyledTabs = styled(Tabs)`
  min-height: 64px;
  .aquilla-tab {
    min-height: 64px;
  }
  ${mediaQuery.uptoMobile} {
    min-height: 44px;
    .aquilla-tab {
      min-height: 44px;
    }
  }
`;

const StyledTabList = styled(TabList)`
  ${mediaQuery.uptoMobile} {
    min-height: 44px;
  }
`;

const Navigation = ({ goalUID, selectedTab, setSelectedTab }) => {
  const { tabs } = useScrollInfo(goalUID);
  const handleTabClick = (data) => {
    setSelectedTab(data);
  };
  return (
    <NavContainer>
      <TabContainer>
        <StyledTabs onChange={handleTabClick} index={selectedTab}>
          <StyledTabList>
            {tabs?.map((tab) => {
              return <Tab key={tab.label}>{tab.label}</Tab>;
            })}
          </StyledTabList>
        </StyledTabs>
      </TabContainer>
    </NavContainer>
  );
};

export default Navigation;
